import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  disclosure_terms_preferential_treatment_flag: {
    name: 'Disclosure Terms Preferential Treatment Flag',
    order: 204
  },
  liquidity_terms_preferential_treatment_flag: {
    name: 'Liquidity Terms Preferential Treatment Flag',
    order: 205
  },
  fee_terms_preferential_treatment_flag: {
    name: 'Fee Terms Preferential Treatment Flag',
    order: 206
  },
  other_terms_preferential_treatment_flag: {
    name: 'Other Terms Preferential Treatment Flag',
    order: 207
  }
};

export function Treatment({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_PREFERENTIAL_TREATMENT,
    onChangeFund,
    schema: schema.INVESTOR_PREFERENTIAL_TREATMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_PREFERENTIAL_TREATMENT?.field_names || [],
    columnLables,
    tableName: 'INVESTOR_PREFERENTIAL_TREATMENT',
    funds,
    isMultiFunds
  });

  return (
    <Table
      id="reporttables-investor-preferential-treatment-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
